export const getMobileOrDesktop = <Value, MobileValue>(
  desktopValue: Value,
  mobileValue: MobileValue | undefined,
  isMobile: boolean,
) => (isMobile ? mobileValue || desktopValue : desktopValue)
